import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { AxiosError } from "axios";

import { RootState } from "features/config/store";
import { DailyEfficiencyTableData } from "features/ms6/core/domain/DailyEfficiencyTableData.model";
import {
  DailyEfficiencyTableDataResponse,
  DailyEfficiencyTableDataRepository,
} from "features/ms6/data/ms6.repository";

export enum dailyEfficiencyTableDataState {
  initial,
  inProgress,
  success,
  fail,
}

interface InitialState {
  status: dailyEfficiencyTableDataState;
  message: string;
  data: DailyEfficiencyTableData | undefined;
}

const initialState: InitialState = {
  status: dailyEfficiencyTableDataState.initial,
  message: "",
  data: undefined,
};

export const dailyEfficiencyTableData = createAsyncThunk(
  "dailyEfficiencyTableData",
  async (_, { rejectWithValue }) => {
    try {
      const response: DailyEfficiencyTableDataResponse =
        await DailyEfficiencyTableDataRepository();
      return response.data;
    } catch (error) {
      if (error instanceof AxiosError) {
        if (!error.response) {
          throw error;
        }
        throw rejectWithValue(error.response.data.message);
      }
    }
  }
);

/* Main Slice */
export const dailyEfficiencyTableDataSlice = createSlice({
  name: "dailyEfficiencyTableData",
  initialState,
  reducers: {
    resetdailyEfficiencyTableData: (state) => {
      state.status = dailyEfficiencyTableDataState.initial;
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(dailyEfficiencyTableData.pending, (state) => {
        state.status = dailyEfficiencyTableDataState.inProgress;
      })
      .addCase(dailyEfficiencyTableData.fulfilled, (state, action) => {
        if (action.payload) {
          const { message, data } = action.payload;
          state.status = dailyEfficiencyTableDataState.success;
          state.message = message;
          state.data = data;
        }
      })
      .addCase(dailyEfficiencyTableData.rejected, (state, action) => {
        state.status = dailyEfficiencyTableDataState.fail;
        state.message = action.payload as string;
      });
  },
});

export const selectdailyEfficiencyTableData = (state: RootState) =>
  state.dailyEfficiencyTableData;
export const { resetdailyEfficiencyTableData } =
  dailyEfficiencyTableDataSlice.actions;
export default dailyEfficiencyTableDataSlice.reducer;
